import { trackRelatedClick } from 'lib/Tracking';
import Link from 'next/link';
import { screen, colors } from 'components/styles/variables';
import { RelatedSlideshow } from 'types/Slideshow';
import { ArticleInterface } from 'types/Apis/ArticleInterface';
import { EventsDataInterface } from './types';

interface RelatedItemProps {
  article: ArticleInterface | RelatedSlideshow;
  eventsData: EventsDataInterface;
  isSlideshow?: boolean;
}

function RelatedItem({ article, eventsData, isSlideshow = false }: RelatedItemProps): JSX.Element {
  const thumbImage = isSlideshow
    ? (article as RelatedSlideshow).thumbnailUrl
    : (article as ArticleInterface).thumb_image;
  const parentPath = isSlideshow ? 'gallery' : (article as ArticleInterface).parent_page.slug;
  const articlePath = `/${parentPath}/${article.slug}`;
  return (
    <li className="related-article">
      <Link href={articlePath} legacyBehavior>
        <a
          className="related-article-link"
          onClick={(): void =>
            trackRelatedClick(eventsData.categoryName, eventsData.pageName, articlePath)
          }
        >
          <img
            className="related-item-thumbnail"
            loading="lazy"
            alt="related article"
            src={thumbImage}
          />
          <h4 className="related-article-title">{article.title}</h4>
        </a>
      </Link>
      <style jsx>{`
        a.related-article-link {
          padding: 0;
          margin: 0;
          width: 100%;
          display: flex;
          text-decoration: none;
        }

        .related-article {
          width: 100%%;
        }

        .related-article {
          padding-bottom: 5px;
          margin-top: 5px;
          border-bottom: 1px solid ${colors.G1};
        }
        .related-article:last-child {
          margin-right: 0;
          border-bottom: none;
        }

        .related-article-link .related-item-thumbnail {
          width: 50%;
          height: 50%;
        }

        .related-article-title {
          font-weight: bold;
          padding-left: 10px;
          padding-top: 0px;
          color: black;
          font-size: 16px;
          font-weight: 600;
          margin: 0;
        }

        @media screen and (min-width: ${screen.smMin}) {
          .related-article {
            width: 33%;
          }
          .related-article-link .related-item-thumbnail {
            width: 100%;
          }

          a.related-article-link {
            display: block;
          }
          .related-article {
            margin: 0;
            margin-right: 7px;
            padding-bottom: 0;
            border-bottom: none;
          }
          .related-article-title {
            padding-top: 10px;
          }
        }
      `}</style>
    </li>
  );
}

export default RelatedItem;
